import script from "./rent_component.vue?vue&type=script&setup=true&lang=js"
export * from "./rent_component.vue?vue&type=script&setup=true&lang=js"

import "./rent_component.vue?vue&type=style&index=0&id=4c8fd759&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8fd759"]])

export default __exports__